export const PREVIEW_PARAM = "preview"
export const CLIENT_PREVIEW_VALUE = "client"

/**
 * Synchronously reads `?preview=client` from the current URL.
 *
 * Intentionally avoids `useSearchParams` so callers don't need to be wrapped
 * in a Suspense boundary and don't deopt their tree into client-side
 * rendering. The trade-off is that consumers won't react to in-page URL
 * changes — fine for our flow, where preview is opened in a new tab.
 */
export const isClientPreviewActive = (): boolean => {
  if (typeof window === "undefined") return false
  return (
    new URLSearchParams(window.location.search).get(PREVIEW_PARAM) ===
    CLIENT_PREVIEW_VALUE
  )
}

export const buildClientPreviewUrl = (url: string): string => {
  if (!url) return ""
  try {
    const parsed = new URL(url)
    parsed.searchParams.set(PREVIEW_PARAM, CLIENT_PREVIEW_VALUE)
    return parsed.toString()
  } catch {
    const separator = url.includes("?") ? "&" : "?"
    return `${url}${separator}${PREVIEW_PARAM}=${CLIENT_PREVIEW_VALUE}`
  }
}
